import { TradePlanData } from '../../../../../classes/tradePlan/tradePlanData';

export function resetSymbolScopedChartState(tradePlanForm: TradePlanData) {
  tradePlanForm.setSetup('AD_HOC');
  tradePlanForm.clearSetupFilters();

  if (tradePlanForm.entryTactics.CANDLE_BREAK) {
    tradePlanForm.removeEntryTactic('CANDLE_BREAK');
  }

  if (tradePlanForm.exitTactics.BREAK_PRICE) {
    tradePlanForm.removeExitTactic('BREAK_PRICE');
  }

  tradePlanForm.clearValidationStatus();
}
